/* istanbul ignore file */
export * from './SearchTipsSection';
